import { supabase } from '@/lib/supabase';

interface UpdateCourseMapProps {
	courseId: string;
	courseName: string;
	disciplineId: string;
	divisionId: string;
	grade: string;
	isAp: boolean;
	isArchived: boolean;
}

export const updateCourseMap = async (variables: UpdateCourseMapProps) => {
	const { courseId, courseName, disciplineId, divisionId, grade, isAp, isArchived } = variables;

	// Update course discipline association
	// First delete existing, then insert new
	await supabase.from('courses_disciplines').delete().eq('course_id', courseId);

	if (disciplineId) {
		const { error: disciplineError } = await supabase.from('courses_disciplines').insert({
			course_id: courseId,
			discipline_id: disciplineId,
		});
		if (disciplineError) throw disciplineError;
	}

	// Update course division association
	// First delete existing, then insert new
	await supabase.from('courses_divisions').delete().eq('course_id', courseId);

	if (divisionId) {
		const { error: divisionError } = await supabase.from('courses_divisions').insert({
			course_id: courseId,
			division_id: divisionId,
		});
		if (divisionError) throw divisionError;
	}

	// Update the course itself
	const { data, error } = await supabase
		.from('courses')
		.update({
			course_name: courseName,
			grade,
			is_ap: isAp,
			is_archived: isArchived,
		})
		.eq('course_id', courseId)
		.select(
			`
			course_id,
			course_name,
			course_division,
			grade,
			is_ap,
			is_archived,
			courses_disciplines (
				discipline:disciplines (
					name
				)
			),
			courses_divisions (
				division:divisions (
					name
				)
			)
		`
		)
		.single();

	if (error) throw error;

	// Transform to match expected structure
	// Handle both array and object return types from Supabase
	const disciplinesRaw = data.courses_disciplines;
	const divisionsRaw = data.courses_divisions;

	const courseDiscipline = Array.isArray(disciplinesRaw) ? disciplinesRaw[0] : disciplinesRaw;
	const courseDivision = Array.isArray(divisionsRaw) ? divisionsRaw[0] : divisionsRaw;

	return {
		...data,
		courses_discipline: courseDiscipline ?? null,
		courses_division: courseDivision ?? null,
	};
};
